module.exports = __webpack_public_path__ + "static/TimesLtPro-SemiboldItalic-3d33a2334f2bf8ca519d5473d0dcd6c8.woff2";